import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/layouts/Layout";
import BreadcrumbBlock from "../../components/BreadcrumbBlock/BreadcrumbBlock";
import {
  Button,
  DatePicker,
  Flex,
  GetProps,
  Input,
  PaginationProps,
  Select,
  SelectProps,
  Table,
  TableColumnsType,
  notification,
} from "antd";
import {
  ArrowSquareDown,
  Calendar,
  Calendar2,
  Category2,
  DocumentDownload,
  Home2,
  SearchZoomIn1,
} from "iconsax-react";
import { Link } from "react-router-dom";
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import "./SalesReport.scss";
import SalesReportItem from "./SalesReportItem";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  LineOutlined,
} from "@ant-design/icons";
import { mixGetV1, mixPostV1 } from "../../services/mixin";
import * as XLSX from "xlsx";
// import type { Dayjs } from 'dayjs'
// import tableData from './tableData.json'

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import ModalListStoreOfSaler from "../Report/Components/ModalListStoreOfSaler";
const { RangePicker } = DatePicker;

type LabelRender = SelectProps["labelRender"];
const customSelectedLabel: LabelRender = (props) => {
  const { label, value } = props;

  if (value && label) {
    return (
      <Flex align="center" gap={8}>
        <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
      <span>Type</span>
    </Flex>
  );
};
const customSelectedLabelPayment: LabelRender = (props) => {
  const { label, value } = props;

  if (value && label) {
    return (
      <Flex align="center" gap={8}>
        <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
        <span>{label}</span>
      </Flex>
    );
  }
  return (
    <Flex align="center" gap={8}>
      <Category2 size={18} variant="Bulk" style={{ flexShrink: 0 }} />
      <span>Payment method</span>
    </Flex>
  );
};
type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;
dayjs.extend(customParseFormat);
const disabledDate: RangePickerProps["disabledDate"] = (current) => {
  // Can not select days after today and today
  return current && current > dayjs().endOf("day");
};

const numberFormat = (number: any) => {
  let result;
  if (typeof number === "number") {
    result = new Intl.NumberFormat().format(number);
  } else {
    result = number;
  }
  return result;
};

const customPrevNext: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement,
) => {
  if (type === "prev") {
    return (
      <Flex align="center" gap={8}>
        <ArrowLeftOutlined />
        <span>Previous</span>
      </Flex>
    );
  }
  if (type === "next") {
    return (
      <Flex align="center" gap={8}>
        <span>Next</span>
        <ArrowRightOutlined />
      </Flex>
    );
  }
  return originalElement;
};

const metricsFilter = [
  { id: "today", label: "Today" },
  { id: "weekly", label: "Weekly" },
  { id: "month", label: "Monthly" },
  { id: "year", label: "Yearly" },
];

const SalesReport: React.FC = () => {
  const [metricFilterSelected, setMetricFilterSelected] = useState("all");
  const [selectedDate, setSelectedDate] = useState(null);
  const [serviceTypes, setServiceTypes] = useState([] as any);
  const [showModalStore, setShowModalStore] = useState(false);
  const role = JSON.parse(localStorage.getItem("user") || "{}")?.role;

  const getStoreTypes = async () => {
    try {
      const res = await mixGetV1("/api/webAdmin/gComboTypeStore.php");

      if (res.status === 1) {
        const result: any = [];
        res.data.map((item: any) =>
          result.push({
            ...item,
            value: item.type_id,
            label: item.type_name,
          }),
        );
        setServiceTypes(result);
      }
    } catch (error) {}
  };
  const onMetricFilter = (id: string) => {
    let time = "all";
    if (metricFilterSelected !== "all" && metricFilterSelected === id) {
      setMetricFilterSelected("all");
      time = "all";
    } else {
      setMetricFilterSelected(id);
      time = id;
    }
    setSelectedDate(null);
    setParams({
      ...params,
      time: time,
    });
  };

  // TABLE
  interface tableColumnType {
    key: React.Key;
    sellerId: number;
    sellerName: string;
    storeType: string;
    phoneNumber: string;
    income: number;
    commission: number;
    storeName: string;
    ownerName: string;
  }
  const columns: TableColumnsType<tableColumnType> = [
    {
      title: "Seller ID",
      dataIndex: "sellerId",
      key: "sellerId",
    },
    {
      title: "Seller name",
      dataIndex: "sellerName",
      key: "sellerName",
    },
    {
      title: "Store type",
      dataIndex: "storeType",
      key: "storeType",
    },
    {
      title: "Income ($)",
      dataIndex: "income",
      key: "income",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Commission ($)",
      dataIndex: "commission",
      key: "commission",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "payment_method",
      dataIndex: "payment_method",
      key: "payment_method",
      render: (value) => <span>{numberFormat(value)}</span>,
    },
    {
      title: "Store name",
      dataIndex: "storeName",
      key: "storeName",
    },
    {
      title: "Owner name",
      dataIndex: "ownerName",
      key: "ownerName",
    },
    {
      title: "Phone number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
    },
    {
      title: "Created at",
      dataIndex: "create_at",
      key: "create_at",
    },
  ];
  // END TABLE

  // GET LIST
  const [items, setItems] = useState({
    list: [],
    total: 0,
    commission: 0,
    income: 0,
    store: 0,
    seller: 0,
  });
  const [tableLoading, setTableLoading] = useState(false);

  const [params, setParams] = useState<{
    limit: number;
    page_number: number;
    searchStoreType?: number | string;
    search_is_cash?: number | string;
    searchKey?: string;
    time?: string;
    toDate?: string;
    fromDate?: string;
  }>({
    limit: 10,
    page_number: 1,
    time: metricFilterSelected,
  });

  const getItems = async () => {
    setTableLoading(true);

    try {
      const apiParams = {
        ...params,
      };
      if (!apiParams.time || apiParams.time === "") {
        apiParams.time = "all";
      }
      const res = await mixPostV1("/api/webAdmin/salesReport.php", apiParams);

      if (res.status === 1) {
        const result: any = res.data.map((item: any, index: number) => ({
          key: index,
          sellerId: item.seller_id,
          sellerName: item.seller_name,
          storeType: item.store_type,
          phoneNumber: item.phone_number,
          income: item.income,
          commission: item.commission,
          storeName: item.store_name,
          ownerName: item.owner_name,
          payment_method: item.payment_method,
          create_at: item.create_at,
        }));
        setItems({
          ...items,
          list: result,
          total: res.totalRecord,
          commission: res.commission,
          income: res.income,
          store: res.totalStore,
          seller: res.totalSale,
        });
        setTableLoading(false);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getStoreTypes();
    getItems();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  const onPageChange = (page: number) => {
    setParams({
      ...params,
      page_number: page,
    });
  };

  const onTableChange = (data: any) => {
    setParams({
      ...params,
      page_number: data.current,
      limit: data.pageSize,
    });
  };
  // END GET LIST

  // SEARCH
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const onSearch = (query: string, type_id?: number | string) => {
    setParams({
      ...params,
      page_number: 1,
      searchKey: query,
      searchStoreType: type_id === "" ? "" : Number(type_id),
    });
  };
  const onEnter = (e: any) => {
    onSearch(e.target.value, params?.searchStoreType ?? "");
  };
  const onChange = (e: any) => {
    clearTimeout(searchTimeout);
    const timeout = setTimeout(() => {
      onSearch(e.target.value, params?.searchStoreType ?? "");
    }, 250);
    setSearchTimeout(timeout);
  };
  const onchangeType = (type_id?: number | string) => {
    clearTimeout(searchTimeout);

    setParams({
      ...params,
      searchStoreType: type_id ? Number(type_id) : "",
    });
  };
  const onchangePaymentMethod = (payment_id?: number | string) => {
    clearTimeout(searchTimeout);

    setParams({
      ...params,
      search_is_cash: payment_id ? Number(payment_id) : "",
    });
  };
  const onRangeChange = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[],
  ) => {
    if (dates) {
      setParams({
        ...params,
        page_number: 1,
        time: "timeline",
        fromDate: dateStrings[0],
        toDate: dateStrings[1],
      });
    } else {
      setParams({
        ...params,
        page_number: 1,
        time: "all",
      });
    }
  };
  // END GET DATE BY DATE

  // EXPORT EXCEL
  const getItemsByExcel = async () => {
    const customParams = {
      ...params,
      page_number: 1,
      limit: 10000,
      time: metricFilterSelected || "all",
    } as any;

    try {
      const res = await mixPostV1(
        "/api/webAdmin/salesReport.php",
        customParams,
      );

      if (res.status) {
        if (res.data.length > 0) {
          formattedDataExcel(res.data);
        } else {
          openNotification("error", "There is no data to export!");
        }
      } else {
        openNotification("error", "Oops, something went wrong!");
      }
    } catch (error) {
      openNotification("error", "Oops, something went wrong!");
    }
  };
  const formattedDataExcel = (data: any) => {
    const formattedData = data.map((item: any) => {
      return {
        "Seller ID": item.seller_id,
        "Seller Name": item.seller_name,
        "Phone number": item.phone_number,
        "Income ($)": item.income,
        "Commission ($)": item.commission,
        "Store name": item.store_name,
        "Owner name": item.owner_name,
      };
    });
    exportExcel(formattedData);
  };
  const exportExcel = (convertData: any): boolean => {
    try {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(convertData);
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Danh sách");

      const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "buffer",
      });

      const saveAsExcel = (buffer: ArrayBuffer, fileName: string): void => {
        const data: Blob = new Blob([buffer], {
          type: "application/octet-stream",
        });
        const link: HTMLAnchorElement = document.createElement("a");
        link.href = window.URL.createObjectURL(data);
        link.download = fileName;
        link.click();
      };

      saveAsExcel(excelBuffer, `${"Sales Report"}.xlsx`);
      return true; // Export successful
    } catch (error) {
      console.error("Error exporting Excel:", error);
      return false; // Export failed
    }
  };
  // END EXPORT EXCEL

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Request success!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  // EXPORT PDF
  const componentRef = useRef() as any;
  const [loadingExportPdf, setLoadingExportPdf] = useState(false);
  const handleDownloadPdf = () => {
    setLoadingExportPdf(true);
    const input = componentRef.current;
    html2canvas(input, {
      scale: 2, // Tăng độ phân giải của canvas để đảm bảo chất lượng cao hơn
      useCORS: true, // Cho phép cross-origin images
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      // Tính toán kích thước của hình ảnh trên PDF
      const imgWidth = 210; // Chiều rộng của A4 là 210mm
      const pageHeight = 295; // Chiều cao của A4 là 295mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;

      // Chèn hình ảnh vào PDF và xử lý nếu hình ảnh dài hơn một trang
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("Sales Report.pdf");
      setLoadingExportPdf(false);
    });
  };

  return (
    <>
      {contextHolder}

      <Layout contentClassName="sales-report-content">
        <BreadcrumbBlock
          items={[
            {
              title: (
                <Flex align="center" gap={16}>
                  <Home2 variant="Bulk" />
                  <Link to="/">CMD Tech</Link>
                </Flex>
              ),
            },
            { title: "Sales report" },
          ]}
          title="Sales report"
          description=""
        />

        <Flex ref={componentRef} vertical gap={18}>
          <Flex align="center" gap={24} className="d-colums-767">
            <Flex align="center" gap={12} className="metric-list">
              {metricsFilter.map((item) => (
                <div
                  key={item.id}
                  className={`metric-item ${
                    metricFilterSelected === item.id ? "active" : ""
                  }`}
                  onClick={() => {
                    onMetricFilter(item.id);
                  }}
                >
                  {item.label}
                </div>
              ))}
            </Flex>

            {/* <DatePicker
              value={selectedDate}
              allowClear
              placeholder="Select date"
              className="rs-date-picker"
              popupClassName="rs-date-picker-dropdown"
              suffixIcon={<Calendar size={18} variant="Bulk" />}
              disabledDate={disabledDate}
              onChange={getDataByDate}
            /> */}
            <RangePicker
              allowClear
              className="rs-range-picker"
              suffixIcon={<Calendar2 size={20} />}
              separator={<LineOutlined />}
              placeholder={["From date", "To date"]}
              disabledDate={disabledDate}
              onChange={onRangeChange}
            />
            <Button
              icon={<DocumentDownload size={20} variant="Bulk" />}
              className="rs-button mis-auto"
              loading={loadingExportPdf}
              onClick={handleDownloadPdf}
            >
              Export PDF
            </Button>
          </Flex>

          <div className="sales-report-list">
            <SalesReportItem title="Seller" number={items.seller} />
            <SalesReportItem
              title="Store"
              number={items.store}
              onItemClick={() => setShowModalStore(true)}
            />
            <SalesReportItem title="Income (USD)" number={items.income} />
            <SalesReportItem
              title="Commission (USD)"
              number={items.commission}
            />
          </div>

          <Flex align="center" gap={16}>
            <Input
              placeholder={`Search by ${role === 3 ? "store" : "seller"} name`}
              prefix={<SearchZoomIn1 size={20} variant="Bulk" />}
              className="rs-input w-full"
              allowClear
              onPressEnter={(e) => onEnter(e)}
              onChange={(e) => onChange(e)}
            />
            <Select
              allowClear={params?.searchStoreType !== ""}
              value={params?.searchStoreType}
              options={serviceTypes}
              placeholder="Type"
              popupMatchSelectWidth={false}
              suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
              labelRender={customSelectedLabel}
              className="rs-select mw-173 mw-100-767 grid-area-type"
              popupClassName="rs-select-dropdown"
              onChange={(value) => {
                onchangeType(value ? Number(value) : "");
              }}
            />
            <Select
              allowClear={params?.search_is_cash !== ""}
              value={params?.search_is_cash}
              options={[
                {
                  value: 1,
                  label: "Cash",
                },
                {
                  value: 2,
                  label: "VISA",
                },
              ]}
              placeholder="Payment method"
              popupMatchSelectWidth={false}
              suffixIcon={<ArrowSquareDown size={20} variant="Bulk" />}
              labelRender={customSelectedLabelPayment}
              className="rs-select mw-173 mw-100-767 grid-area-type"
              popupClassName="rs-select-dropdown"
              onChange={(value) => {
                onchangePaymentMethod(value ? Number(value) : "");
              }}
            />
            <Button
              icon={<DocumentDownload size={20} variant="Bulk" />}
              className="rs-button h-[40px] w-[102px]"
              onClick={getItemsByExcel}
            >
              Export
            </Button>
          </Flex>

          <Table
            columns={columns}
            dataSource={items.list}
            className="rs-table table-text-nowrap match-height"
            loading={tableLoading}
            scroll={{
              x: true,
            }}
            pagination={{
              current: params.page_number,
              pageSize: params.limit,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTitle: false,
              total: items.total,
              itemRender: customPrevNext,
              onChange: (e) => onPageChange(e),
            }}
            onChange={onTableChange}
          />
        </Flex>
      </Layout>
      <ModalListStoreOfSaler
        isShow={showModalStore}
        onPopupClose={() => setShowModalStore(false)}
        params={params}
      />
    </>
  );
};

export default SalesReport;
